import { Component, NgZone, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Constants } from '../common/constants';
import { HttpUtils } from '../common/http-utils';
import { SelectService } from '../common/select-service';
import { Toast } from '../common/toast';
import { Utils } from '../common/utils';
import { LoaderService } from '../common/loader-service';
import { NgForm } from '@angular/forms';
import { Route } from '../common/route';
import { Pattern } from '../common/pattern';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { SimpleModalService } from 'ngx-simple-modal';
import { LocalStorage } from '../common/local-storage';
import { GUI } from '../common/gui';
import { FileUploadModalComponent } from '../file-upload-modal/file-upload-modal.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-application-add-edit',
  templateUrl: './application-add-edit.component.html',
  styleUrls: ['./application-add-edit.component.css'],
})
export class ApplicationAddEditComponent {
  @ViewChild('generalDetailsForm') generalDetailsForm: NgForm;

  @ViewChild('personalDetailsForm') personalDetailsForm: NgForm;

  @ViewChild('travelDetailsForm') travelDetailsForm: NgForm;

  @ViewChild('contactDetailsForm') contactDetailsForm: NgForm;

  @ViewChild('supportingDocumentsForm') supportingDocumentsForm: NgForm;

  @ViewChild('travelHistoryForm') travelHistoryForm: NgForm;

  @ViewChild('securityDetailsForm') securityDetailsForm: NgForm;

  @ViewChild('biometricDetailsForm') biometricDetailsForm: NgForm;

  private masterEncrypedApplicantId: string = this.constants.BLANK;

  applicationStage: number = this.constants.GENERAL_INFO_STEP;

  applicationHighestStage: number = this.constants.GENERAL_INFO_STEP;

  generalDetailsFormObject: any = {};

  feeDetailsObject: any = {};

  personalDetailsFormObject: any = {};

  travelDetailsFormObject: any = {};

  contactDetailsFormObject: any = {};

  travelHistoryFormObject: any = {};

  securityFormObject: any = {};

  biometricFormObject: any = {};

  supportingDocumentsFormObject: any = {};

  nationalitySelectService = new SelectService();

  visaClassSelectService = new SelectService();

  passportSelectService = new SelectService();

  countrySelectService = new SelectService();

  stateSelectService = new SelectService();

  private shallExitApplication: boolean;

  isShowApplicationIdMessage: boolean = false;

  isShowFeesSection: boolean = false;

  contactPhoneNumberOptions = this.utils.fetchIntTelOptionsObject(false);

  applicationStepsList: any = [
    {
      count: this.constants.GENERAL_INFO_STEP,
      id: 'general',
      label: 'General Information',
    },
    {
      count: this.constants.PERSONAL_INFO_STEP,
      id: 'personal',
      label: 'Biodata',
    },
    {
      count: this.constants.TRAVEL_INFO_STEP,
      id: 'travel',
      label: 'Travel Information',
    },
    {
      count: this.constants.CONTACT_INFO_STEP,
      id: 'contact',
      label: 'Contact/Hotel details in Nigeria',
    },
    {
      count: this.constants.SUPPORTING_DOCUMENTS_STEP,
      id: 'document',
      label: 'Supporting Documents',
    },
    {
      count: this.constants.TRAVEL_HISTORY_STEP,
      id: 'history',
      label: 'Travel History',
    },
    {
      count: this.constants.SECURITY_AND_CRIMINAL_HISTORY_STEP,
      id: 'security',
      label: 'Security and Criminal History',
    },
    {
      count: this.constants.BIOMETRIC_INFORMATION_STEP,
      id: 'biometric',
      label: 'Biometric Information',
    },
  ];

  monthsList: any = [];



  formDocumentsValid: boolean = false;



  dependentDocuments: any[];

  dependentSupportingDocumentsFormObject: any = {};


  currentAddressStateFieldType: string = this.constants.TEXT_FIELD;

  private loggedUserId: string = this.constants.BLANK;

  serverDate: string = this.constants.BLANK;

  isAfricanCountry: number;

  ageFactorObject: any = {
    isMinAgeRestricted: this.constants.TRUE,
    isMaxAgeRestricted: this.constants.TRUE,
    minAge: this.constants.MINIMUM_AGE_VALUE,
    maxAge: this.constants.MAXIMUM_AGE_VALUE,
  };

  visaClassFullObjects: any = {};

  dependents: any[] = [];

  numberOfDependent: number = 2;

  nextId = 1;

  // ngOnInit(): void {
  //   this.initializeDependentDocuments();
  // }


  passportMinExpiryDate: string = this.constants.BLANK;

  private allowImagesList = 'image/jpg, image/png, image/jpeg';

  private allowImagesAndPDFList =
    'image/jpg, image/png, image/jpeg, application/pdf';

  isApplicantImageExist: boolean = false;

  supportingDocumentsList: any = [];

  minDepartureDate = new Date();

  minArrivalDate = new Date();



  public canAcceptDependant: boolean = false;
  public selectedVisaClassObject: any;
  // public visaClassFullObjects: any[] = [];




  constructor(
    private activatedRoute: ActivatedRoute,
    private route: Route,
    private httpUtils: HttpUtils,
    private toast: Toast,
    public utils: Utils,
    public constants: Constants,
    private loaderService: LoaderService,
    public pattern: Pattern,
    private simpleModalService: SimpleModalService,
    private localStorage: LocalStorage,
    private gui: GUI
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.masterEncrypedApplicantId = params['applicantId'];
    });
    this.loggedUserId = this.localStorage.getLoggedUserId();
    this.storeCountriesList();
    // this.utils.storePassportTypes(this.passportSelectService);
    this.monthsList = this.utils.getMonthsArray();
    this.minDepartureDate = this.utils.getFlooredDate(this.minDepartureDate);
    this.setDefaultMinArrivalDate();

    if (this.utils.isEmpty(this.masterEncrypedApplicantId) === false) {
      this.storeApplicationData();
      return;
    }

    this.setFormsDefaultValues();
  }

  private setFormsDefaultValues(): void {
    this.setGeneralDetailsFormDefaultValues();
    this.setPersonalDetailsFormDefaultValues();
    this.setTravelDetailsFormDefaultValues();
    this.setContactDetailsFormDefaultValues();
    this.setSupportingDocumentsFormDefaultValues();
    this.setTravelHistoryFormDefaultValues();
    this.setSecurityFormDefaultValues();
    this.setBiometricFormDefaultValues();
    this.setCallableFunction();
  }

  private setGeneralDetailsFormDefaultValues() {
    this.setFieldsToBlank(
      this.generalDetailsFormObject,
      ['nationality', 'visaClass', 'passportType'],
      [this.visaClassSelectService, this.passportSelectService],
      true
    );
  }

  private setPersonalDetailsFormDefaultValues() {
    this.setFieldsToBlank(
      this.personalDetailsFormObject,
      ['title', 'dateOfBirthMonth', 'gender', 'maritalStatus'],
      null,
      false
    );
    this.personalDetailsFormObject.isFixedCropper = this.constants.TRUE;
    this.personalDetailsFormObject.allowFileTypeList = this.allowImagesList;
  }

  private setTravelDetailsFormDefaultValues() {
    this.setFieldsToBlank(
      this.travelDetailsFormObject,
      ['travelInfoId', 'entryPort', 'departureCountry'],
      null,
      false
    );
  }

  private setContactDetailsFormDefaultValues() {
    this.setFieldsToBlank(
      this.contactDetailsFormObject,
      ['contactState'],
      [this.stateSelectService],
      false
    );
  }

  private setSupportingDocumentsFormDefaultValues(): void {
    this.supportingDocumentsFormObject.isFixedCropper = this.constants.FALSE;
    this.supportingDocumentsFormObject.allowFileTypeList =
      this.allowImagesAndPDFList;


    this.dependentSupportingDocumentsFormObject.isFixedCropper = this.constants.FALSE;
    this.dependentSupportingDocumentsFormObject.allowFileTypeList =
      this.allowImagesAndPDFList;
  }

  private setTravelHistoryFormDefaultValues() {
    // this.setFieldsToBlank(
    //   this.contactDetailsFormObject,
    //   ['contactState'],
    //   [this.stateSelectService],
    //   false
    // );
  }

  private setSecurityFormDefaultValues() {
    // this.setFieldsToBlank(
    //   this.contactDetailsFormObject,
    //   ['contactState'],
    //   [this.stateSelectService],
    //   false
    // );
  }

  private setBiometricFormDefaultValues() {
    // this.setFieldsToBlank(
    //   this.contactDetailsFormObject,
    //   ['contactState'],
    //   [this.stateSelectService],
    //   false
    // );
  }
  private setCallableFunction() {
    this.generalDetailsFormObject.callableFunctionName =
      'openPersonalDetailsForm';
    this.personalDetailsFormObject.callableFunctionName =
      'openTravelDetailsForm';
    this.travelDetailsFormObject.callableFunctionName =
      'openContactDetailsForm';
    this.contactDetailsFormObject.callableFunctionName =
      'openSupportingDocumentsForm';
    this.supportingDocumentsFormObject.callableFunctionName =
      'openTravelHistoryForm';
    this.travelHistoryFormObject.callableFunctionName =
      'openSecurityDetailsForm';
    this.securityFormObject.callableFunctionName =
      'openBiometricDetailsForm';
    this.biometricFormObject.callableFunctionName =
      'openApplicationPreview';
  }

  private fetchCurrentForm() {
    if (this.generalDetailsForm !== undefined) {
      return this.generalDetailsForm;
    }

    if (this.personalDetailsForm !== undefined) {
      return this.personalDetailsForm;
    }

    if (this.travelDetailsForm !== undefined) {
      return this.travelDetailsForm;
    }

    if (this.contactDetailsForm !== undefined) {
      return this.contactDetailsForm;
    }

    if (this.supportingDocumentsForm !== undefined) {
      return this.supportingDocumentsForm;
    }


    if (this.travelHistoryForm !== undefined) {
      return this.travelHistoryForm;
    }

    if (this.securityDetailsForm !== undefined) {
      return this.securityDetailsForm;
    }

    return this.biometricDetailsForm;
  }

  openFieldSet(stage: number, event: any) {
    window.scrollTo(0, 0);
    const currentForm = this.fetchCurrentForm();

    if (currentForm === null) {
      return;
    }

    currentForm.onSubmit(event);

    if (currentForm.valid === true) {
      if (
        currentForm.form.contains('hasFieldValueChanged') &&
        currentForm.form.value.hasFieldValueChanged === this.constants.TRUE
      ) {
        const callableFunctionName =
          currentForm.form.value.callableFunctionName;
        this.showDataChangeInformationModal(event, callableFunctionName);
      } else {
        this.applicationStage = stage;
      }
    }
  }

  private showDataChangeInformationModal(
    event: any,
    callableFunctionName: string
  ) {
    const message =
      'It seems you have changed some content on this page. <br> Would you like to save the data first?';
    const modalParamsObject = {
      title: 'Confirmation',
      message: message,
      confirmButtonLabel: 'YES',
      cancelButtonLabel: 'NO',
      isShowCancelButton: true,
    };
    this.simpleModalService
      .addModal(ConfirmationModalComponent, modalParamsObject, {
        autoFocus: true,
      })
      .subscribe((isConfirmed: boolean) => {
        if (isConfirmed === true) {
          event.target.name = 'confirmation';
          this[callableFunctionName](event);
        }
      });
  }

  openPreviousFieldSet() {
    this.applicationStage--;
  }

  setShallExitApplication(shallExitApplication: boolean) {
    this.shallExitApplication = shallExitApplication;
  }

  private openInformationModal() {
    // const message = 'APPLICATION NUMBER <b>'+this.personalDetailsFormObject.applicationId+'</b> (IMPORTANT - PLEASE WRITE DOWN THE APPLICATION NUMBER. YOU MAY REQUIRE IT LATER)';
    // const modalParamsObject = {title: 'Information', message: message, confirmButtonLabel: 'OK', cancelButtonLabel: 'Cancel', isShowCancelButton: false};
    // this.simpleModalService.addModal(ConfirmationModalComponent, modalParamsObject, {autoFocus: true}).subscribe((isConfirmed: boolean)=> {
    //   if(isConfirmed === true){
    //     this.openDashboardPage();
    //   }
    // });
    this.openDashboardPage();
  }

  openDashboardPage() {
    this.gui.openDashboardPage();
  }

  setGender() {
    if (this.personalDetailsFormObject.title === this.constants.BLANK) {
      this.personalDetailsFormObject.gender = this.constants.BLANK;
      return;
    }

    if (this.personalDetailsFormObject.title === this.constants.MR) {
      this.personalDetailsFormObject.gender = this.constants.MALE;
      return;
    }

    this.personalDetailsFormObject.gender = this.constants.FEMALE;
  }

  private isValidDetails(checkedFieldsArray: any = []) {
    let fieldBlankCount = this.constants.FALSE;

    for (let i = 0; i < checkedFieldsArray.length; i++) {
      if (
        this.utils.isEmpty(
          this.generalDetailsFormObject[checkedFieldsArray[i]]
        ) === true
      ) {
        fieldBlankCount++;
      }
    }

    return fieldBlankCount === this.constants.FALSE;
  }

  setFieldsToBlank(
    formObject: {},
    fieldsArray: any[],
    selectServiceArray: SelectService[],
    isFeeObjectEffected: boolean
  ) {
    for (let i = 0; i < fieldsArray.length; i++) {
      formObject[fieldsArray[i]] = this.constants.BLANK;
    }

    if (selectServiceArray !== null) {
      for (let selectService of selectServiceArray) {
        selectService.setSelectOptions([this.utils.defaultSelectOption]);
      }
    }

    if (isFeeObjectEffected === true) {
      this.isShowFeesSection = false;
      this.feeDetailsObject = {};
    }
  }

  private setDateOfBirth() {
    const dateOfBirthArray =
      this.personalDetailsFormObject.dateOfBirth.split('/');
    this.personalDetailsFormObject.dateOfBirthDay = dateOfBirthArray[0];
    this.personalDetailsFormObject.dateOfBirthMonth = dateOfBirthArray[1];
    this.personalDetailsFormObject.dateOfBirthYear = dateOfBirthArray[2];
  }

  private setDependentsDateOfBirth() {

    if (Array.isArray(this.dependents)) {
      this.dependents.forEach(dependent => {
        if (dependent.dateOfBirth) {
          const dateOfBirthArray = dependent.dateOfBirth.split('/');

          if (dateOfBirthArray.length >= 3) {
            dependent.dateOfBirthDay = dateOfBirthArray[0] || '';
            dependent.dateOfBirthMonth = dateOfBirthArray[1] || '';
            dependent.dateOfBirthYear = dateOfBirthArray[2] || '';
          } else {
            console.warn('Invalid date format for dependent:', dependent.dateOfBirth);
            dependent.dateOfBirthDay = '';
            dependent.dateOfBirthMonth = '';
            dependent.dateOfBirthYear = '';
          }
        } else {
          dependent.dateOfBirthDay = '';
          dependent.dateOfBirthMonth = '';
          dependent.dateOfBirthYear = '';
        }
      });
    } else {
      console.warn('Expected this.dependents to be an array, but got:', this.dependents);
    }

  }

  private storeCountriesList() {
    this.loaderService.startLoader();
    this.httpUtils.fetchCountriesList().then((serverResponse) => {
      this.loaderService.stopLoader();
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        if (environment.isEnableAdminConfig === true) {
          this.storeCountriesWithAdminConfig(serverResponse);
          return;
        }
        const serverNationalityList = [this.utils.defaultSelectOption];
        const serverCountryList = [this.utils.defaultSelectOption];
        for (const valueJSONObject of serverResponse.countries) {
          if (valueJSONObject.isApplicableCountry === this.constants.TRUE) {
            serverNationalityList.push({
              value: valueJSONObject.isoCode,
              text: valueJSONObject.fullName,
            });
          }
          serverCountryList.push({
            value: valueJSONObject.isoCode,
            text: valueJSONObject.fullName,
          });
        }
        this.nationalitySelectService.setSelectOptions(serverNationalityList);
        this.countrySelectService.setSelectOptions(serverCountryList);
        this.passportMinExpiryDate = serverResponse.passportMinExpiryDate;
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  private storeCountriesWithAdminConfig(serverResponse: any = {}): void {
    const serverNationalityList = [this.utils.defaultSelectOption];
    const serverCountryList = [this.utils.defaultSelectOption];

    for (const valueJSONObject of serverResponse.voaCountries) {
      serverNationalityList.push({
        value: valueJSONObject.isoCode,
        text: valueJSONObject.fullName,
      });
    }

    for (const valueJSONObject of serverResponse.countries) {
      serverCountryList.push({
        value: valueJSONObject.isoCode,
        text: valueJSONObject.fullName,
      });
    }

    this.nationalitySelectService.setSelectOptions(serverNationalityList);
    this.countrySelectService.setSelectOptions(serverCountryList);
    this.passportMinExpiryDate = serverResponse.passportMinExpiryDate;
  }

  storeVisaClassList(isChangedFromGUI: boolean): void {
    this.loaderService.startLoader();

    if (isChangedFromGUI === true) {
      this.setFieldsToBlank(
        this.generalDetailsFormObject,
        ['visaClass', 'passportType'],
        [this.visaClassSelectService],
        true
      );
    }

    if (this.isValidDetails(['nationality']) === false) {
      this.loaderService.stopLoader();
      return;
    }

    this.httpUtils
      .fetchVisaClasses(this.generalDetailsFormObject.nationality)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          const serverList = [this.utils.defaultSelectOption];
          const visaClassObjects = [];
          for (const valueJSONObject of serverResponse.visaClasses) {
            visaClassObjects.push(valueJSONObject);
            serverList.push({
              value: valueJSONObject.visaClass,

              text:
                valueJSONObject.visaClass +
                ' - ' +
                valueJSONObject.visaClassLabel,
            });
          }
          this.visaClassSelectService.setSelectOptions(serverList);
          this.visaClassFullObjects = visaClassObjects;
          this.isAfricanCountry = serverResponse.isAfricanCountry;
          this.serverDate = serverResponse.serverDate;
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });
  }

  setSelectedVisaClassObject(): void {
    const selectedValue = this.generalDetailsFormObject.visaClass;
    this.selectedVisaClassObject = this.visaClassFullObjects.find(
      item => item.visaClass === selectedValue
    );

    if (this.selectedVisaClassObject) {
      this.canAcceptDependant = this.selectedVisaClassObject.visaClassCanAcceptDependant;

    } else {
      this.canAcceptDependant = false;
    }
  }

  storePassportList(isChangedFromGUI: boolean): void {
    this.loaderService.startLoader();

    if (isChangedFromGUI === true) {
      this.setFieldsToBlank(
        this.generalDetailsFormObject,
        ['passportType'],
        [this.passportSelectService],
        true
      );
    }

    if (this.isValidDetails(['nationality']) === false) {
      this.loaderService.stopLoader();
      return;
    }

    this.httpUtils
      .fetchPassports(this.generalDetailsFormObject.nationality)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          const serverList = [this.utils.defaultSelectOption];
          for (const valueJSONObject of serverResponse.passports) {
            serverList.push({
              value: valueJSONObject.passportType,
              text: valueJSONObject.passportLabel,
            });
          }
          this.passportSelectService.setSelectOptions(serverList);
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });
  }

  setAgeRestrictionObject(): void {
    const visaClass = this.generalDetailsFormObject.visaClass;
    const isMinAgeRestricted =
      visaClass === this.constants.F5A
        ? this.constants.FALSE
        : this.constants.TRUE;
    this.ageFactorObject.isMinAgeRestricted = isMinAgeRestricted;

    this.setFieldsToBlank(
      this.generalDetailsFormObject,
      ['passportType'],
      null,
      true
    );
  }

  // setAgeRestrictionObject(): void {
  //   const visaClass = this.generalDetailsFormObject.visaClass;

  //   // List of visa classes that apply to minors
  //   const minorVisaClasses = [
  //     this.constants.F3B,
  //     this.constants.F5A,
  //     this.constants.F6A,
  //     this.constants.F7F,
  //     this.constants.F7I,
  //     this.constants.F9B
  //   ];

  //   // If visaClass is one of the minors, restriction = FALSE; else TRUE
  //   const isMinAgeRestricted = minorVisaClasses.includes(visaClass)
  //     ? this.constants.FALSE
  //     : this.constants.TRUE;

  //   this.ageFactorObject.isMinAgeRestricted = isMinAgeRestricted;

  //   this.setFieldsToBlank(
  //     this.generalDetailsFormObject,
  //     ['passportType'],
  //     null,
  //     true
  //   );
  // }


  fetchVisaFeeDetails() {
    if (
      this.isValidDetails(['nationality', 'visaClass', 'passportType']) ===
      false
    ) {
      this.isShowFeesSection = false;
      this.feeDetailsObject = {};
      return;
    }
    this.loaderService.startLoader();

    this.localStorage.setStorageKey("tempPassportType", this.generalDetailsFormObject.passportType)

    this.generalDetailsFormObject.passportType = "STANDARD"

    this.httpUtils
      .fetchVisaFeeDetails(this.generalDetailsFormObject)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          this.feeDetailsObject = serverResponse.feeDetails;
          this.isShowFeesSection = true;
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
          this.isShowFeesSection = false;
          this.feeDetailsObject = {};
          // this.generalDetailsFormObject.passportType = tempPassportType;

        }
      });


  }


  private setApplicationLatestStage(currentStage: number) {
    this.applicationStage = currentStage;
    this.applicationHighestStage = currentStage;
  }

  private markFieldValueUnchanged(event: any, formObject: {}) {
    event.target.name = this.constants.BLANK;
    formObject['hasFieldValueChanged'] = this.constants.FALSE;
  }

  openPersonalDetailsForm(event: any) {


    if (this.isShowFeesSection === false) {
      this.toast.showErrorToast(
        'Fee not found in the system, Please try again'
      );
      return;
    }

    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);

    this.loaderService.startLoader();

    if (
      this.utils.isEmpty(this.personalDetailsFormObject.applicationId) === true
    ) {
      this.setApplicationLatestStage(this.constants.PERSONAL_INFO_STEP);
      this.loaderService.stopLoader();
      return;
    }

    this.generalDetailsFormObject.applicantId =
      this.personalDetailsFormObject.applicantId;
    this.generalDetailsFormObject.applicationId =
      this.personalDetailsFormObject.applicationId;
    this.generalDetailsFormObject.loggedUserId = this.loggedUserId;

    this.httpUtils
      .updateGeneralDetails(this.generalDetailsFormObject)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          this.markFieldValueUnchanged(event, this.generalDetailsFormObject);
          this.setApplicationLatestStage(this.constants.PERSONAL_INFO_STEP);
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });
  }

  openTravelDetailsForm(event: any) {
    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);

    this.loaderService.startLoader();
    this.personalDetailsFormObject.dateOfBirth =
      this.personalDetailsFormObject.dateOfBirthDay +
      '/' +
      this.personalDetailsFormObject.dateOfBirthMonth +
      '/' +
      this.personalDetailsFormObject.dateOfBirthYear;
    this.personalDetailsFormObject.loggedUserId = this.loggedUserId;

    // To remove on monday
    // if (this.personalDetailsFormObject.gender === "FEMALE") {
    //   this.personalDetailsFormObject.title = "Mrs"
    // } else {
    //   this.personalDetailsFormObject.title = "Mr"

    // }



    this.httpUtils.saveGeneralAndBioDetails(
      this.personalDetailsFormObject,
      this.generalDetailsFormObject
    ).then((mainApplicationResponse) => {
      if (mainApplicationResponse.responseCode !== this.constants.STATUS_SUCCESS) {
        this.loaderService.stopLoader();
        this.toast.showErrorToast(mainApplicationResponse.responseMsg);
        return;
      }

      // Save main application IDs
      const applicationID = mainApplicationResponse.applicantId;
      this.personalDetailsFormObject.applicantId = applicationID;
      this.personalDetailsFormObject.applicationId = mainApplicationResponse.applicationId;
      this.isShowApplicationIdMessage = true;
      this.markFieldValueUnchanged(event, this.personalDetailsFormObject);

      // Early exit if needed
      if (this.shallExitApplication) {
        this.loaderService.stopLoader();
        this.openInformationModal();
        return;
      }

      // Process dependents if any exist
      if (!this.dependents?.length) {
        this.loaderService.stopLoader();
        this.setApplicationLatestStage(this.constants.TRAVEL_INFO_STEP);
        return;
      }

      const dependentPromises = this.dependents.map(async (dependent, index) => {
        const dependentWithParent = {
          ...dependent,
          loggedUserId: this.loggedUserId,
          parentId: applicationID,
          dateOfBirth: this.formatDateOfBirth(
            dependent.dateOfBirthDay,
            dependent.dateOfBirthMonth,
            dependent.dateOfBirthYear
          )
        };

        const generalDetails = {
          ...this.generalDetailsFormObject,
          ...(dependent?.nationality && { nationality: dependent.nationality }),
          ...(this.personalDetailsFormObject?.applicantId && { applicantId: dependent?.applicantId }),
        };

        try {
          const response = await this.httpUtils.saveGeneralAndBioDetails(dependentWithParent, generalDetails);

          if (response.responseCode === this.constants.STATUS_SUCCESS) {
            // ✅ Save returned applicantId to the dependent object
            this.dependents[index].applicantId = response.applicantId;
          }

          return response;
        } catch (err) {
          return { responseCode: 'ERROR', responseMsg: 'Dependent save failed' };
        }
      });


      // Keep loader running while saving dependents
      Promise.all(dependentPromises)
        .then(responses => {
          const failedResponses = responses.filter(
            r => r.responseCode !== this.constants.STATUS_SUCCESS
          );

          if (failedResponses.length) {
            this.toast.showErrorToast(failedResponses[0].responseMsg);
            this.loaderService.stopLoader();
            return;
          }

          this.setApplicationLatestStage(this.constants.TRAVEL_INFO_STEP);
          this.loaderService.stopLoader();
        })
        .catch(error => {
          console.error('Dependent save error:', error);
          this.toast.showErrorToast('Failed to save dependent information');
          this.loaderService.stopLoader();
        });
    }).catch((error) => {
      console.error('Main application save error:', error);
      this.toast.showErrorToast('Failed to save application');
      this.loaderService.stopLoader();
    });


  }
  private formatDateOfBirth(day: string, month: string, year: string): string {
    const pad = (num: string) => num?.padStart(2, '0') || '00';
    return `${pad(day)}/${pad(month)}/${year}`;
  }

  openContactDetailsForm(event: any) {
    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);
    this.loaderService.startLoader();
    this.travelDetailsFormObject.loggedUserId = this.loggedUserId;
    this.travelDetailsFormObject.applicantId =
      this.personalDetailsFormObject.applicantId;

    this.httpUtils
      .saveTravelDetails(this.travelDetailsFormObject)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          // this.initializeNumberOfDependents()
          // this.initializeDependentDocuments()
          this.travelDetailsFormObject.applicantId = serverResponse.applicantId;
          this.travelDetailsFormObject.travelInfoId =
            serverResponse.travelInfoId;
          this.markFieldValueUnchanged(event, this.travelDetailsFormObject);

          if (this.shallExitApplication === true) {
            this.openInformationModal();
            return;
          }

          this.storeStateList();

          this.setApplicationLatestStage(this.constants.CONTACT_INFO_STEP);
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });
  }

  private storeStateList() {
    this.loaderService.startLoader();
    this.httpUtils.fetchCountryStateList().then((serverResponse) => {
      this.loaderService.stopLoader();
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        const serverList = [this.utils.defaultSelectOption];
        for (const valueJSONObject of serverResponse.states) {
          serverList.push({
            value: valueJSONObject.id,
            text: valueJSONObject.stateName,
          });
        }
        this.stateSelectService.setSelectOptions(serverList);
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  openSupportingDocumentsForm(event: any): void {
    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);

    this.loaderService.startLoader();
    this.contactDetailsFormObject.loggedUserId = this.loggedUserId;
    this.contactDetailsFormObject.applicantId = this.personalDetailsFormObject.applicantId;
    this.httpUtils.saveContactDetails(this.contactDetailsFormObject).then(serverResponse => {
      this.loaderService.stopLoader();
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.contactDetailsFormObject.contactDetailsId = serverResponse.contactDetailsId;
        this.contactDetailsFormObject.applicantId = serverResponse.applicantId;

        this.markFieldValueUnchanged(event, this.contactDetailsFormObject);

        if (this.shallExitApplication === true) {
          this.openInformationModal();
          return;
        }

        this.storeSupportingDocumentsList();

        this.setApplicationLatestStage(this.constants.SUPPORTING_DOCUMENTS_STEP);
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }








  openTravelHistoryForm(event: any) {
    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);

    this.loaderService.startLoader();

    const documentsList = [];
    for (let requiredDocument of this.supportingDocumentsList) {
      documentsList.push({
        key: requiredDocument.id,
        value:
          this.supportingDocumentsFormObject[
          'fileBase64Data' + requiredDocument.id
          ],
      });
    }


    const requestObject: any = {};
    requestObject.loggedUserId = this.loggedUserId;
    requestObject.applicantId = this.personalDetailsFormObject.applicantId;
    requestObject.documentsList = documentsList;

    // const dependentDocumentsSet = new Map(); // Using Map to preserve insertion order

    // for (const dependent of this.dependentDocuments) {
    //   for (const document of dependent.visaDocumentsDTOs) {
    //     const fileData = this.dependentSupportingDocumentsFormObject['fileBase64Data' + document.id];

    //     if (fileData && !dependentDocumentsSet.has(document.id)) {
    //       dependentDocumentsSet.set(document.id, {
    //         key: document.id,
    //         value: fileData,
    //       });
    //     }
    //   }
    // }

    // const dependentDocumentsList = Array.from(dependentDocumentsSet.values());

    // Create request object for each dependent's documents
    // const dependentRequests = this.dependentDocuments.map(dependent => {
    //   // Get unique document IDs for this dependent
    //   const docIds = [...new Set(dependent.visaDocumentsDTOs.map(d => d.id))];

    //   return {
    //     loggedUserId: this.loggedUserId,
    //     applicantId: dependent.applicantId,
    //     documentsList: docIds.map(id => ({
    //       key: id,
    //       value: this.dependentSupportingDocumentsFormObject['fileBase64Data' + id]
    //     })).filter(doc => doc.value) // Only include if value exists
    //   };
    // });


    // First build a map of all document data
    const allDocumentsMap = new Map();
    for (const dependent of this.dependentDocuments) {
      for (const document of dependent.documents) {
        const fileData = this.dependentSupportingDocumentsFormObject['fileBase64Data' + document.applicantId + '_' + document.id];
        if (fileData) {
          allDocumentsMap.set(document.id, {
            key: document.id,
            value: fileData,
          });
        }
      }
    }

    // Then create requests by looking up documents for each dependent
    const dependentRequests = this.dependentDocuments.map(dependent => {
      const uniqueDocIds = [...new Set(dependent.documents.map(d => d.id))];

      console.log("uniqueDocIds", uniqueDocIds)

      return {
        loggedUserId: this.loggedUserId,
        applicantId: dependent.applicantId,
        documentsList: uniqueDocIds
          .map(id => allDocumentsMap.get(id))
          .filter(Boolean) // Remove undefined entries
      };
    });


    // console.log("dependentRequests", dependentRequests)
    // console.log("allDocumentsMap", allDocumentsMap)
    // console.log("dependentDocuments", this.dependentDocuments)
    // console.log("dependentDocuments", this.dependentSupportingDocumentsFormObject)

    // this.httpUtils
    //   .saveSupportingDocuments(requestObject)
    //   .then((serverResponse) => {
    //     this.loaderService.stopLoader();

    //     if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {

    //       // Check if dependentRequests exists and has items
    //       if (Array.isArray(dependentRequests) && dependentRequests.length > 0) {
    //         for (const depRequest of dependentRequests) {
    //           this.httpUtils
    //             .saveSupportingDocuments(depRequest)
    //             .then(depRes => {
    //               if (depRes.responseCode !== this.constants.STATUS_SUCCESS) {
    //                 this.toast.showErrorToast(
    //                   `Error saving dependent documents for applicantId ${depRequest.applicantId}: ${depRes.responseMsg}`
    //                 );
    //               }
    //             })
    //             .catch(error => {
    //               this.toast.showErrorToast(
    //                 `Request failed for applicantId ${depRequest.applicantId}: ${error.message}`
    //               );
    //             });
    //         }
    //       }

    //       // Always proceed regardless of whether there are dependents
    //       this.markFieldValueUnchanged(event, this.supportingDocumentsFormObject);

    //       if (this.shallExitApplication === true) {
    //         this.openInformationModal();
    //         return;
    //       }

    //       this.setApplicationLatestStage(this.constants.TRAVEL_HISTORY_STEP);

    //     } else {
    //       this.toast.showErrorToast(serverResponse.responseMsg);
    //     }
    //   })
    //   .catch(error => {
    //     this.loaderService.stopLoader();
    //     this.toast.showErrorToast(`Main request failed: ${error.message}`);
    //   });


    this.httpUtils
      .saveSupportingDocuments(requestObject)
      .then((serverResponse) => {
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          if (Array.isArray(dependentRequests) && dependentRequests.length > 0) {
            // Process dependent requests and wait for all to complete
            const dependentPromises = dependentRequests.map(depRequest =>
              this.httpUtils.saveSupportingDocuments(depRequest)
                .then(depRes => {
                  if (depRes.responseCode !== this.constants.STATUS_SUCCESS) {
                    this.toast.showErrorToast(
                      `Error saving dependent documents for applicantId ${depRequest.applicantId}: ${depRes.responseMsg}`
                    );
                    return false;
                  }
                  return true;
                })
                .catch(error => {
                  this.toast.showErrorToast(
                    `Request failed for applicantId ${depRequest.applicantId}: ${error.message}`
                  );
                  return false;
                })
            );

            return Promise.all(dependentPromises).then(results => {
              const allSuccessful = results.every(res => res === true);

              if (allSuccessful) {
                this.markFieldValueUnchanged(event, this.supportingDocumentsFormObject);

                if (this.shallExitApplication === true) {
                  this.openInformationModal();
                } else {
                  this.setApplicationLatestStage(this.constants.TRAVEL_HISTORY_STEP);
                }
              } else {
                this.toast.showErrorToast("Some dependent documents failed to save. Process halted.");
              }
            });
          } else {
            // No dependents, proceed directly
            this.markFieldValueUnchanged(event, this.supportingDocumentsFormObject);

            if (this.shallExitApplication === true) {
              this.openInformationModal();
            } else {
              this.setApplicationLatestStage(this.constants.TRAVEL_HISTORY_STEP);
            }
          }
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      })
      .catch(error => {
        this.toast.showErrorToast("Request failed please try again");
      })
      .finally(() => {
        // Always stop loader at the end
        this.loaderService.stopLoader();
      });






  }


  openSecurityDetailsForm(event: any) {
    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);

    this.loaderService.startLoader();



    this.travelHistoryFormObject.loggedUserId = this.loggedUserId;
    this.travelHistoryFormObject.applicantId = this.personalDetailsFormObject.applicantId;
    this.httpUtils
      .saveTravelHistory(this.travelHistoryFormObject)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          this.travelHistoryFormObject.travelHistoryId = serverResponse.travelHistoryId;
          this.markFieldValueUnchanged(
            event,
            this.travelHistoryFormObject
          );

          if (this.shallExitApplication === true) {
            this.openInformationModal();
            return;
          }
          this.setApplicationLatestStage(this.constants.SECURITY_AND_CRIMINAL_HISTORY_STEP);
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });



  }

  openBiometricDetailsForm(event: any) {
    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);

    this.loaderService.startLoader();

    this.securityFormObject.loggedUserId = this.loggedUserId;
    this.securityFormObject.applicantId = this.personalDetailsFormObject.applicantId;

    this.httpUtils
      .saveSecurityHistory(this.securityFormObject)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          this.securityFormObject.securityHistoryId = serverResponse.securityHistoryId;
          this.markFieldValueUnchanged(
            event,
            this.securityFormObject
          );

          if (this.shallExitApplication === true) {
            this.openInformationModal();
            return;
          }
          this.setApplicationLatestStage(this.constants.BIOMETRIC_INFORMATION_STEP);
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });



  }


  // handlePersonalDetailsSubmit(form: NgForm, event: Event): void {
  //   form.control.markAllAsTouched();

  //   let hasAgeError = false;

  //   if (Array.isArray(this.dependentDocuments)) {
  //     this.dependentDocuments.forEach(dep => {
  //       this.validateDependentAge(dep);
  //       dep.formSubmitted = true;
  //       if (dep.ageError) {
  //         hasAgeError = true;
  //       }
  //     });
  //   }

  //   if (hasAgeError) {
  //     return;
  //   }

  //   if (form.valid) {
  //     this.openTravelDetailsForm(event);
  //   } else {
  //     const firstInvalid = document.querySelector('.ng-invalid');
  //     if (firstInvalid) {
  //       firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //     }
  //   }
  // }

  handlePersonalDetailsSubmit(form: NgForm, event: Event): void {
    form.control.markAllAsTouched();

    const dependentsAreValid = this.checkAllDependentsAge();
    if (!dependentsAreValid) return;

    if (form.valid) {
      this.openTravelDetailsForm(event);
    } else {
      const firstInvalid = document.querySelector('.ng-invalid');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }






  // private storeSupportingDocumentsList(): void {
  //   this.loaderService.startLoader();

  //   const visaDetails = {
  //     visaClass: this.generalDetailsFormObject.visaClass,
  //     applicantId: this.personalDetailsFormObject?.applicantId
  //   }
  //   this.httpUtils
  //     .fetchSupportingDocumentsList(visaDetails)
  //     .then((serverResponse) => {
  //       this.loaderService.stopLoader();
  //       if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
  //         this.supportingDocumentsList = serverResponse.supportingDocuments;
  //         this.dependentDocuments = serverResponse.dependantsSupportingDocuments;
  //       } else {
  //         this.toast.showErrorToast(serverResponse.responseMsg);
  //       }
  //     });
  // }

  // When fetching dependent documents
  private storeSupportingDocumentsList(): void {
    this.loaderService.startLoader();

    const visaDetails = {
      visaClass: this.generalDetailsFormObject.visaClass,
      applicantId: this.personalDetailsFormObject?.applicantId
    };

    this.httpUtils.fetchSupportingDocumentsList(visaDetails)
      .then((serverResponse) => {
        this.loaderService.stopLoader();

        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          // Process main supporting documents
          this.supportingDocumentsList = serverResponse.supportingDocuments;

          // Process dependent documents with applicantId included in each document
          this.dependentDocuments = this.transformDependentDocuments(
            serverResponse.dependantsSupportingDocuments
          );
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      })
      .catch(error => {
        this.loaderService.stopLoader();
        // this.toast.showErrorToast('Failed to load supporting documents');
        console.error('Error fetching supporting documents:', error);
      });
  }

  private transformDependentDocuments(dependantsSupportingDocuments: any[]): any[] {
    if (!Array.isArray(dependantsSupportingDocuments)) {
      console.warn('transformDependentDocuments: Expected an array but got:', dependantsSupportingDocuments);
      return [];
    }

    return dependantsSupportingDocuments.map(dependent => {
      const applicantId = dependent?.applicantId;

      return {
        ...dependent,
        fileData: dependent?.fileData || {},  // ✅ Ensure fileData is at least an empty object
        visaDocumentsDTOs: Array.isArray(dependent?.documents)
          ? dependent.documents.map(document => ({
            ...document,
            applicantId: applicantId,
            fileBase64Data: null,
            fileType: null
          }))
          : []
      };
    });
  }






  openApplicationPreview(event: any) {
    if (this.utils.isEmpty(event.target.name) === true) {
      return;
    }

    window.scrollTo(0, 0);

    this.loaderService.startLoader();
    this.biometricFormObject.loggedUserId = this.loggedUserId;
    this.biometricFormObject.applicantId = this.personalDetailsFormObject.applicantId;
    this.httpUtils
      .saveBiometricInfo(this.biometricFormObject)
      .then((serverResponse) => {
        this.loaderService.stopLoader();
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          this.biometricFormObject.biometricInfoId = serverResponse.biometricInfoId;
          this.markFieldValueUnchanged(
            event,
            this.biometricFormObject
          );

          if (this.shallExitApplication === true) {
            this.openInformationModal();
            return;
          }

          this.gui.openApplicationViewPage(serverResponse.applicantId);
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });
  }

  private storeApplicationData() {
    this.loaderService.startLoader();
    const applicantId = this.utils.decryptString(
      this.masterEncrypedApplicantId
    );
    this.httpUtils
      .fetchApplicationData(applicantId, this.loggedUserId)
      .then((serverResponse) => {
        if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
          this.loaderService.stopLoader();
          this.setupGeneralDetailsFormObject(serverResponse);

          this.setupFeeDetailsObject(serverResponse);

          this.setupPersonalDetailsFormObject(serverResponse);

          this.setupTravelDetailsFormObject(serverResponse);

          this.setupContactDetailsFormObject(serverResponse);

          this.setupSupportingDocumentsFormObject(serverResponse);

          this.setupTravelHistoryFormObject(serverResponse);
          this.setupSecurityFormObject(serverResponse);
          this.setupBiometricFormObject(serverResponse);
          this.setCallableFunction();
        } else {
          this.toast.showErrorToast(serverResponse.responseMsg);
        }
      });
  }

  private setupGeneralDetailsFormObject(serverResponse: any = {}) {
    if (serverResponse.generalDetails !== null) {
      this.generalDetailsFormObject = serverResponse.generalDetails;
      this.storeVisaClassList(false);
      this.storePassportList(false);
      this.supportingDocumentsList = serverResponse.supportingDocuments;
      this.dependentDocuments = this.transformDependentDocuments(
        serverResponse.dependantsSupportingDocuments
      );
    }
  }

  private setupFeeDetailsObject(serverResponse: any = {}) {
    if (serverResponse.feeDetails !== null) {
      this.feeDetailsObject = serverResponse.feeDetails;
      this.isShowFeesSection = true;
    }
  }

  private setupPersonalDetailsFormObject(serverResponse: any = {}) {
    if (serverResponse.bioDetails !== null) {
      this.personalDetailsFormObject = serverResponse.bioDetails;
      this.dependents = serverResponse.dependantsDetails;
      console.log("this.dependents", this.dependents)
      this.setApplicationLatestStage(
        this.personalDetailsFormObject.applicationStage
      );
      this.personalDetailsFormObject.isFixedCropper = this.constants.TRUE;
      this.personalDetailsFormObject.allowFileTypeList = this.allowImagesList;

      // Add properties to each dependent
      if (this.dependents && this.dependents.length > 0) {
        this.dependents.forEach(dependent => {
          dependent.isFixedCropper = this.constants.TRUE;
          dependent.allowFileTypeList = this.allowImagesList;
        });
      }

      this.isApplicantImageExist =
        this.utils.isEmpty(this.personalDetailsFormObject.passportImageData) ===
        false;
      this.isShowApplicationIdMessage = true;
      this.setDateOfBirth();
      this.setDependentsDateOfBirth();
    } else {
      this.setPersonalDetailsFormDefaultValues();
    }
  }

  private setupTravelDetailsFormObject(serverResponse: any = {}) {
    if (serverResponse.travelDetails !== null) {
      this.travelDetailsFormObject = serverResponse.travelDetails;
    } else {
      this.setTravelDetailsFormDefaultValues();
    }
  }

  private setupContactDetailsFormObject(serverResponse: any = {}) {
    if (serverResponse.contactDetails !== null) {
      this.contactDetailsFormObject = serverResponse.contactDetails;
      this.storeStateList();
      if (
        this.utils.isEmpty(this.contactDetailsFormObject.countryISO) === false
      ) {
        this.contactPhoneNumberOptions.initialCountry =
          this.contactDetailsFormObject.countryISO;
      }
    } else {
      this.setContactDetailsFormDefaultValues();
    }
  }

  handleFormSubmit(form: NgForm, event: Event) {
    form.control.markAllAsTouched();

    let hasAgeError = false;
    let hasMissingDependentDocs = false;

    // Check age for dependents
    if (Array.isArray(this.dependentDocuments)) {
      this.dependentDocuments.forEach(dep => {
        this.validateDependentAge(dep);
        dep.formSubmitted = true;
        if (dep.ageError) {
          hasAgeError = true;
        }
      });

      // Check that all dependent documents are uploaded
      for (const dependent of this.dependentDocuments) {
        for (const doc of dependent.visaDocumentsDTOs) {
          const key = 'fileBase64Data' + doc.applicantId + '_' + doc.id;
          if (!this.dependentSupportingDocumentsFormObject[key]) {
            hasMissingDependentDocs = true;
            break;
          }
        }
        if (hasMissingDependentDocs) break;
      }
    }

    // Block if age validation fails
    if (hasAgeError) {
      this.toast.showErrorToast('All dependents must be under 18 years old.');
      return;
    }

    // Block if any dependent document is missing
    if (hasMissingDependentDocs) {
      this.toast.showErrorToast('Please upload all required dependent documents.');
      return;
    }

    // Proceed if form is valid and all checks passed
    if (form.valid) {
      this.openTravelHistoryForm(event);
    } else {
      const firstInvalid = document.querySelector('.ng-invalid');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }



  saveAndExit() {
    this.setShallExitApplication(true);
    this.supportingDocumentsForm.ngSubmit.emit();
  }

  trackByF(index: number, item: any): any {
    return item.id || index;
  }

  trackByDocument(index: number, item: any): any {
    return item.id || index;
  }


  private setupSupportingDocumentsFormObject(serverResponse: any = {}): void {
    if (serverResponse.documentsDetails !== null) {
      const serverDocumentsDetails = serverResponse.documentsDetails;
      this.supportingDocumentsFormObject = serverDocumentsDetails;
      this.dependentSupportingDocumentsFormObject = serverDocumentsDetails;

      const applicationDocumentsKeyList = Object.keys(serverDocumentsDetails);

      for (let objectKey of applicationDocumentsKeyList) {
        this.supportingDocumentsFormObject['fileBase64Data' + objectKey] =
          serverDocumentsDetails[objectKey][1];
        this.supportingDocumentsFormObject['fileType' + objectKey] =
          serverDocumentsDetails[objectKey][2];
      }


      this.dependentDocuments.forEach(dependent => {
        dependent.visaDocumentsDTOs.forEach(document => {
          if (!this.dependentSupportingDocumentsFormObject['fileBase64Data' + document.id]) {
            this.dependentSupportingDocumentsFormObject['fileBase64Data' + document.id] = null;
            this.dependentSupportingDocumentsFormObject['fileType' + document.id] = null;
          }
        });
      });


      this.supportingDocumentsFormObject.isFixedCropper = this.constants.FALSE;
      this.supportingDocumentsFormObject.allowFileTypeList =
        this.allowImagesAndPDFList;

      this.dependentSupportingDocumentsFormObject.isFixedCropper = this.constants.FALSE;
      this.dependentSupportingDocumentsFormObject.allowFileTypeList =
        this.allowImagesAndPDFList;
    } else {
      this.setSupportingDocumentsFormDefaultValues();
    }
  }

  private setupTravelHistoryFormObject(serverResponse: any = {}) {
    if (serverResponse.travelHistoryDetails !== null) {
      this.travelHistoryFormObject = serverResponse.travelHistoryDetails;
      this.storeStateList();
      // if (
      //   this.utils.isEmpty(this.contactDetailsFormObject.countryISO) === false
      // ) {
      //   this.contactPhoneNumberOptions.initialCountry =
      //     this.contactDetailsFormObject.countryISO;
      // }
    } else {
      this.setTravelHistoryFormDefaultValues();
    }
  }

  private setupSecurityFormObject(serverResponse: any = {}) {
    if (serverResponse.securityDetails !== null) {
      this.securityFormObject = serverResponse.securityDetails;
      this.storeStateList();
      if (
        this.utils.isEmpty(this.contactDetailsFormObject.countryISO) === false
      ) {
        this.contactPhoneNumberOptions.initialCountry =
          this.contactDetailsFormObject.countryISO;
      }
    } else {
      this.setSecurityFormDefaultValues();
    }
  }

  private setupBiometricFormObject(serverResponse: any = {}) {
    if (serverResponse.biometricDetails !== null) {
      this.biometricFormObject = serverResponse.biometricDetails;
      this.storeStateList();
      if (
        this.utils.isEmpty(this.contactDetailsFormObject.countryISO) === false
      ) {
        this.contactPhoneNumberOptions.initialCountry =
          this.contactDetailsFormObject.countryISO;
      }
    } else {
      this.setBiometricFormDefaultValues();
    }
  }


  validateAllRequiredDocuments() {
    let allDependentDocsValid = true;

    if (Array.isArray(this.dependentDocuments)) {
      allDependentDocsValid = this.dependentDocuments.every(dependent => {
        return dependent.visaDocumentsDTOs.every(doc => {
          const key = 'fileBase64Data' + doc.applicantId + '_' + doc.id;
          return !!this.dependentSupportingDocumentsFormObject[key]; // required by default
        });
      });
    }

    this.formDocumentsValid = allDependentDocsValid;
  }




  openFileUploadModal(
    formObject: {},
    fileDataField: string,
    fileTypeField: string,
    isProfilePicUploaded: boolean
  ): void {
    const requestObject = {};
    requestObject['fileBase64Data'] = formObject[fileDataField];
    requestObject['fileType'] = formObject[fileTypeField];
    requestObject['isFixedCropper'] = formObject['isFixedCropper'];
    requestObject['allowFileTypeList'] = formObject['allowFileTypeList'];
    requestObject['isProfilePicUploaded'] = isProfilePicUploaded;
    this.simpleModalService
      .addModal(
        FileUploadModalComponent,
        { requestObject: requestObject },
        { autoFocus: true }
      )
      .subscribe((responseObject: any = {}) => {
        if (Object.keys(responseObject).length > 0) {
          formObject[fileDataField] = responseObject.fileBase64Data;
          formObject[fileTypeField] = responseObject.fileType;
          this.isApplicantImageExist =
            this.utils.isEmpty(responseObject.fileBase64Data) === false;
        }
      });
  }

  deleteUploadedFile(
    formObject: {},
    fileDataField: string,
    fileTypeField: string
  ) {
    formObject[fileDataField] = this.constants.BLANK;
    formObject[fileTypeField] = this.constants.BLANK;
  }

  private setDefaultMinArrivalDate(): void {
    let minArrivalDate = new Date();
    minArrivalDate = this.utils.getFlooredDate(minArrivalDate);
    this.utils.addDays(minArrivalDate, 3);

    this.minArrivalDate = minArrivalDate;
  }

  setMinArrivalDate(): void {
    this.setDefaultMinArrivalDate();

    const departureDateString =
      this.travelDetailsFormObject.expectedDepartureDate;
    if (this.utils.isEmpty(departureDateString) === true) {
      return;
    }

    const departureDate = this.utils.getJSDate(departureDateString);
    if (departureDate.getTime() < this.minArrivalDate.getTime()) {
      return;
    }

    this.utils.addDays(departureDate, 0);
    this.minArrivalDate = departureDate;
  }


  addDependent() {
    // Initialize dependents array if it's undefined
    if (!this.dependents) {
      this.dependents = [];
    }

    // Check maximum limit
    if (this.dependents.length < this.constants.MAX_DEPENDENTS) {
      this.dependents.push({
        id: this.nextId++,
        title: '',
        lastName: '',
        firstName: '',
        middleName: '',
        dateOfBirthDay: '',
        dateOfBirthMonth: '',
        dateOfBirthYear: '',
        placeOfBirth: '',
        passportImageData: '',
        passportImageFileType: '',
        gender: '',
        passportNumber: '',
        passportExpiryDate: '',
        nigerianPassport: false,
        nigerianPassportNumber: '',
        formSubmitted: false,
        ageError: false,
        nationality: "",
        allowFileTypeList: this.allowImagesList,
        isFixedCropper: this.constants.TRUE
      });
    } else {
      this.toast.showErrorToast(`Maximum of ${this.constants.MAX_DEPENDENTS} dependents allowed`);
    }
  }

  removeDependent(id: number) {
    // Make sure we have a valid array
    if (!this.dependents || !Array.isArray(this.dependents)) {
      console.error('Dependents array is invalid');
      return;
    }

    // Create new array without the dependent
    const newDependents = this.dependents.filter(d => d.id !== id);

    // Check if anything was actually removed
    if (newDependents.length === this.dependents.length) {
      console.warn(`No dependent found with ID ${id}`);
      return;
    }

    // Update the array reference
    this.dependents = newDependents;

    // Optional: Show feedback
    this.toast.showSuccessToast('Dependent removed successfully');
  }
  clearAllDependents() {
    this.dependents = [];
  }


  private isUnder18(dobDay: string, dobMonth: string, dobYear: string): boolean {
    if (!dobDay || !dobMonth || !dobYear) return true; // Consider invalid dates as valid for UI

    const birthDate = new Date(`${dobMonth}/${dobDay}/${dobYear}`);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age < 18;
  }


  validateDependentAge(dependent: any): void {
    const day = parseInt(dependent.dateOfBirthDay, 10);
    const month = parseInt(dependent.dateOfBirthMonth, 10);
    const year = parseInt(dependent.dateOfBirthYear, 10);

    dependent.ageError = false;

    if (isNaN(day) || isNaN(month) || isNaN(year)) return;

    const dob = new Date(year, month - 1, day);
    const today = new Date();

    if (
      dob.getFullYear() !== year ||
      dob.getMonth() !== month - 1 ||
      dob.getDate() !== day ||
      dob > today
    ) {
      dependent.ageError = true;
      return;
    }

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    if (age > 18) {
      dependent.ageError = true;
    }

    // Optional: log for debugging
    // console.log({ dob, today, age, ageError: dependent.ageError });
  }




  checkAllDependentsAge(): boolean {
    if (!Array.isArray(this.dependents)) {
      console.warn('checkAllDependentsAge: this.dependents is not an array:', this.dependents);
      return true;
    }

    let isValid = true;

    this.dependents.forEach(dep => {
      dep.formSubmitted = true;
      this.validateDependentAge(dep);
      if (dep.ageError) {
        isValid = false;
      }
    });

    if (!isValid) {
      this.toast.showErrorToast('All dependents must be 18 years old or younger.');
    }

    return isValid;
  }





  showAgeError(dependent: any): boolean {
    return (
      dependent.ageError &&
      !!dependent.dateOfBirthDay &&
      !!dependent.dateOfBirthMonth &&
      !!dependent.dateOfBirthYear
    );
  }





}
